import { render, staticRenderFns } from "./InspectionTable.vue?vue&type=template&id=34e8d0cc&scoped=true"
import script from "./InspectionTable.vue?vue&type=script&lang=js"
export * from "./InspectionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e8d0cc",
  null
  
)

export default component.exports